<template>
  <div v-if="current_user">
    <breadcrumb />
    <h2>Nuevo Aviso Clasificado</h2>
    <br />
    <v-card raised>
      <form @submit.prevent="sendFile">
        <v-layout row wrap pa-4>
          <v-flex md4 pl-4>
            <v-text-field
              v-model="product.name"
              :error-messages="nameErrors"
              :counter="60"
              label="Nombre del producto/servicio"
              required
              @input="$v.product.name.$touch()"
              @blur="$v.product.name.$touch()"
            ></v-text-field>
          </v-flex>
          <v-flex md4 pl-4>
            <v-text-field
              v-model="current_user.email"
              :error-messages="emailErrors"
              label="E-mail de contacto"
              required
              disabled
              @input="$v.product.email.$touch()"
              @blur="$v.product.email.$touch()"
              id="email"
            ></v-text-field>
          </v-flex>
          <v-flex md4 pl-4>
            <v-select 
              :items="options" 
              v-model="product.type" 
              label="Tipo de producto"
              required
              @input="$v.product.type.$touch()"
              @blur="$v.product.type.$touch()"
              :error-messages="typeErrors"
            ></v-select>
          </v-flex>
          <v-flex md2 pl-4>
            <v-select
              v-model="product.currency"
              :items="currency_options"
              label="Tipo de moneda"
              required
            ></v-select>
          </v-flex>
          <v-flex md3 pl-4>
            <v-text-field
              v-model="formatProductPrice"
              type="text"
              :error-messages="priceErrors"
              label="Precio"
              required
              @input="$v.product.price.$touch()"
              @blur="isInputActive = false"
              @focus="isInputActive = true"
            ></v-text-field>
          </v-flex>
          <v-flex md2 pl-4>
            <v-text-field
              v-model="current_user.annexed"
              :error-messages="phoneErrors"
              label="Teléfono"
              required
              disabled
              @input="$v.product.phone.$touch()"
              @blur="$v.product.phone.$touch()"
            ></v-text-field>
          </v-flex>
          <v-flex md5 pl-4>
            <v-text-field
              v-model="userLocation"
              :error-messages="locationErrors"
              label="Dirección/Oficina"
              required
              @input="$v.product.location.$touch()"
            ></v-text-field>
          </v-flex>
          <v-flex md8 pl-4>
            <v-textarea
              v-model="product.description"
              name="input-7-1"
              label="Descripción del producto"
              hint="Ingrese la descripción completa del producto o servicio a publicar"
            ></v-textarea>
          </v-flex>
          <v-flex xs6 md6 sm12 xs12 pl-4>
            <h2 class="subheading">Subir fotos del producto o servicio:</h2>
            <input type="file" ref="files" multiple="true" accept="image/*" @change="selectFiles()" />
            <br />
            <br />
          </v-flex>
          <v-flex md sm12 xs12 text-xs-right>
            <v-btn
              type="submit"
              class="white--text"
              color="#638d37"
            >{{action == "post" ? "Crear Aviso" : "Actualizar"}}</v-btn>
            <v-btn @click="clear">Limpiar</v-btn>
          </v-flex>
        </v-layout>
      </form>
    </v-card>
  </div>
</template>

<script>
import config from "@/config";
import { mapState } from "vuex";
import { validationMixin } from "vuelidate";
import Breadcrumb from "@/components/General/Breadcrumb";
import axios from "axios";
import Swal from "sweetalert2";
import {
  required,
  minLength,
  email,
  maxLength,
  integer
} from "vuelidate/lib/validators";
import {} from "vuelidate/lib/validators";
export default {
  mixins: [validationMixin],
  components: {
    Breadcrumb
  },
  data() {
    return {
      selected: null,
      options: [
        { text: "Seleccione una opción", value: null },
        { text: "Autos", value: "Autos" },
        { text: "Propiedades", value: "Propiedades" },
        { text: "Servicios", value: "Servicios" },
        { text: "Varios", value: "Varios" }
      ],
      currency_options: [
        { text: "$", value: "$"},
        { text: "UF", value: "UF"}
      ],
      images: [],
      isInputActive: false
    };
  },
  props: {
    product: {
      type: Object,
      required: true
    },
    productSubmit: {
      type: String,
      default: "Crear Aviso"
    },
    action: {
      type: String,
      required: true
    }
  },
  validations: {
    product: {
      name: {
        required,
        minLength: minLength(3)
      },
      email: {
        required,
        email
      },
      description: {
        maxLength: maxLength(500)
      },
      price: {
        required,
        integer
      },
      phone: {
        required
      },
      location: { required },
      type: { required }
    }
  },
  computed: {
    checkboxErrors() {
      const errors = [];
      if (!this.$v.checkbox.$dirty) return errors;
      !this.$v.checkbox.checked && errors.push("You must agree to continue!");
      return errors;
    },
    selectErrors() {
      const errors = [];
      if (!this.$v.select.$dirty) return errors;
      !this.$v.select.required && errors.push("Item is required");
      return errors;
    },
    nameErrors() {
      const errors = [];
      if (!this.$v.product.name.$dirty) return errors;
      !this.$v.product.name.minLength &&
        errors.push("Nombre debe contener mínimo 3 caracteres");
      !this.$v.product.name.required && errors.push("El nombre es requerido.");
      return errors;
    },
    emailErrors() {
      const errors = [];
      if (!this.$v.product.email.$dirty) return errors;
      !this.$v.product.email.email && errors.push("Must be valid e-mail");
      !this.$v.product.email.required && errors.push("E-mail is required");
      return errors;
    },
    priceErrors() {
      const errors = [];
      if (!this.$v.product.price.$dirty) return errors;
      !this.$v.product.price.required &&
        errors.push("El precio es obligatorio");
      return errors;
    },
    phoneErrors() {
      const errors = [];
      if (!this.$v.product.phone.$dirty) return errors;
      !this.$v.product.phone.required &&
        errors.push("El teléfono es obligatorio");
      return errors;
    },
    locationErrors() {
      const errors = [];
      if (!this.$v.product.location.$dirty) return errors;
      !this.$v.product.location.required &&
        errors.push("La ubicación es obligatoria");
      return errors;
    },
    typeErrors() {
      const errors = [];
      if (!this.$v.product.type.$dirty) return errors;
      !this.$v.product.type.required &&
        errors.push("Tipo de producto es obligatorio");
      return errors;
    },
    formatProductPrice: {
      get() {
        if (this.isInputActive) {
          // Si input está activo, retorna valor sin formato (Sólo números)
          if (this.product.price) return this.product.price.toString();         
        } else {
          // Si input está inactivo, retorna el valor con formato (con el ".")
          if (this.product.price) {
            return this.product.price.toFixed(0).replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, "$1.")
          }
        }
      },
      set(modifiedValue) {
        // Modifica el valor dejándolo en un formato de sólo números
        let newValue = parseFloat(modifiedValue.replace(/[^\d\.]/g, ""))
        // Si el valor no es número (NaN), deja el valor como "0"
        if (isNaN(newValue)) newValue = 0;
        // Actualiza con un $emit el nuevo valor de sólo números
        this.$emit('update-price', newValue)
      }
    },
    userLocation: {
      get() {
        return this.product.location ? this.product.location : this.current_user.address;
      },
      set(value) {
        this.product.location = value;
      }
    },
    ...mapState("user", ["current_user"])
  },
  mounted() {
    // this.email = this.$refs.email.dataset.value; // See note below
  },
  methods: {
    clear() {
      this.$v.product.$reset();
      this.product.name = "";
      this.product.email = "";
      this.product.price = "";
      this.product.phone = "";
      this.product.description = "";
      this.product.location = "";
      this.product.type = "";
      this.product.currency = "$";
    },
    submit() {
      this.product.$v.$touch();
    },
    sendFile() {
      if (!this.product.location) this.product.location = this.current_user.address;
      this.product.email = this.current_user.email;
      this.product.phone = this.current_user.annexed;

      this.$v.$touch();

      if (this.$v.$invalid) {
        return;
      }

      const formData = new FormData();
      for (let key in this.files) {
        formData.append("images[" + key + "]", this.files[key]);
      }
      formData.append("name", this.product.name);
      formData.append("email", this.current_user.email);
      formData.append("currency", this.product.currency);
      formData.append("price", this.product.price);
      formData.append("phone", this.current_user.annexed);
      formData.append("product_type", this.product.type);
      formData.append("description", this.product.description);
      formData.append("location", this.product.location);
      formData.append("approved", false);
      formData.append("user_id", this.current_user.id);
      formData.append("expiration", 30);
      this.getRequest(formData);
    },
    getRequest(formData) {
      Swal.fire({ title: "Estamos procesando tu solicitud..." });
      Swal.showLoading();
      if (this.action == "post") {
        try {
          axios
            .post(`/frontend/products/`, formData)
            .then(response => {
              this.getMessage(response.status);
            })
            .catch(e => {
              console.log(e);
            });
        } catch (err) {
          console.log(err);
        }
      } else {
        try {
          axios
            .put(`/frontend/products/${this.product.id}`, formData)
            .then(response => {
              this.getMessage(response.status);
            })
            .catch(e => {
              console.log(e);
            });
        } catch (err) {
          console.log(err);
        }
      }
    },
    getMessage(status) {
      if (status == "200") {
        Swal.fire({
          title: "¡Gracias! Hemos recibido la información. Te confirmaremos por correo cuando tu aviso clasificado esté publicado.",
          timer: 2000,
          type: "success"
        });
        this.$router.push({ name: "products" });
      } else {
        Swal.fire({
          title: "Hubo un error con su petición.",
          timer: 2000,
          type: "error"
        });
      }
    },
    selectFiles() {
      this.files = this.$refs.files.files;
      let count = 1;
      let a = [];
      let fs = this.files;
      let error = false;

      Array.prototype.forEach.call(fs, function(f) {
        let reader = new FileReader();
        // Closure to capture the file information.
        reader.onload = (function(theFile) {
          reader.readAsBinaryString(theFile);
          
          // Validando tipo de imagen
          if (theFile.type === 'image/jpeg' || theFile.type === 'image/png') {
            error = false;
          } else {
            Swal.fire({
              title: "El formato de la foto es inválido, debes subir una foto en formato jpg o png y debe tener tamaño de 250x200 o superior."
            });
            error = true;
          }

          return function(e) {
            let binaryData = e.target.result;
            //Converting Binary Data to base 64
            let base64String = window.btoa(binaryData);
            //adding file converted to array of images
            a.push(base64String);
          };
        })(f);
      });

      if (error) {
        this.files = '';
        this.$refs.files.value = '';
        return;
      }

      this.files = a;
    }
  }
};
</script>